import { noop } from 'lodash';
import { useHistory } from 'react-router';

import { Form, useForm } from '@shared/forms/components/Form';
import { TextField } from '@shared/forms/components/TextField';
import { getTimeTrackingGroup } from '@shared/time-tracking-groups/endpoints/getTimeTrackingGroup';
import {
  UpdateTimeTrackingGroupData,
  updateTimeTrackingGroup,
} from '@shared/time-tracking-groups/endpoints/updateTimeTrackingGroup';
import { Portlet } from '@shared/ui/components/Portlet';
import { ObjectWithId } from '@shared/utils/types';

import { AdminWrapper } from '@admin/layout/components/AdminWrapper';
import RegistrationMultiSelectField from '@admin/time-tracking-groups/components/RegistrationMultiSelectField/RegistrationMultiSelectField';

export function EditTimeTrackingGroup({ match }: any) {
  const { push } = useHistory();

  const { form, fields } = useForm<UpdateTimeTrackingGroupData>({
    source: {
      id: match.params.id,
      provider: ({ id }: ObjectWithId) => {
        return getTimeTrackingGroup({ id }).then((timeTrackingGroup) => ({
          ...timeTrackingGroup,
          registrationIds: timeTrackingGroup.registrations!.map((registration) => registration.id),
        }));
      },
    },
  });

  const timeTrackingGroupId: number = match.params.id;

  return (
    <AdminWrapper
      title="Edit Time Tracking Group"
      breadcrumb={{ label: 'Time Tracking Groups', url: '/admin/time-tracking-groups' }}
    >
      <Portlet>
        <Form
          action={(data) => updateTimeTrackingGroup({ id: timeTrackingGroupId }, data)}
          onSave={noop}
          onSaveAndReturn={() => push('/admin/time-tracking-groups')}
          onCancel={() => push('/admin/time-tracking-groups')}
          form={form}
        >
          <TextField name={fields.name} label="Name" />
          <RegistrationMultiSelectField name="registrationIds" label="Registrations" />
        </Form>
      </Portlet>
    </AdminWrapper>
  );
}
